module.exports = __webpack_public_path__ + "product/add-quote-list-38b67a8efc90beec21a69ddf9a600193.svg";